Controller = require 'controller'
FileLinkHandler = require 'views/internal/file-link-handler'
isWebClientPage = require 'lib/util/url/is-web-client-page'
Layout = require 'views/lib/layout'
ModelCache = require 'db/model-cache'
PopOver = require 'views/lib/pop-over'
Dialog = require 'views/lib/dialog'
shouldHandleClick = require 'lib/util/should-handle-click'
SidebarState = require 'view-models/sidebar-state'
trackUe = require 'debug/trackUe'
Util = require 'lib/util'
$ = require 'jquery'
{ Noun, Verb } = require 'common/debug/analytics-constants'

handleLinkClick = (e) ->
  $a = $(e.target).closest('a')
  href = $a.attr('href')
  if !href || href == '#'
    Util.preventDefault(e)
  else if href.indexOf('file://') == 0
    Util.preventDefault(e)
    FileLinkHandler($a[0])
  else if href.indexOf('/') == 0 || href.indexOf(siteDomain + '/') == 0
    urlTarget = href
      .replace(/// ^ #{ siteDomain } ///, '')
      .replace(/// ^ /(?=.) ///, '')

    # location.pathname has a leading "/"; urlTarget does not
    isNewUrl = urlTarget != location.pathname.slice(1)

    if window != window.top && navigatesOffBoard(urlTarget)
      Util.preventDefault(e)
      window.open(urlTarget)
      return

    # If the page is just a virtual route served by the controller, we don't
    # need to reload the page. Unless it has target="_blank", because when
    # you "attach" a Trello card to another card you get an "open in a new
    # tab" link that we don't want to intercept.
    if isWebClientPage(href) && !$a.attr('target')?
      Util.preventDefault(e)
      if isNewUrl
        Controller.navigate(urlTarget, { trigger: true })

  return

# In cases where we're framed, we want to intercept navigation to other parts
# of Trello, and open those in new windows
navigatesOffBoard = (urlTarget) ->
  if (currentBoard = Controller.getCurrentBoard())?
    # If we're not a relative URL for a card or board, then we can't be on
    # the same board
    parts = ///^([bc])/([^/]+)///.exec(urlTarget)
    if !parts?
      return true

    [all, modelLetter, shortLink] = parts

    switch modelLetter
      when 'b'
        shortLink != currentBoard.get('shortLink')
      when 'c'
        ModelCache.get('Card', shortLink)?.getBoard() != currentBoard
      else
        true
  else
    # If we're not on a board right now, don't worry about navigating
    # off of it
    false

module.exports = (e) ->
  board = Controller.getCurrentBoard()
  boardView = board && Controller.getCurrentBoardView()
  $target = $(e.target)

  if PopOver.isVisible && !PopOver.hardToClose && $target.closest('.pop-over').length == 0 && $target.closest('body').length > 0
    PopOver.hide()

  else if !PopOver.isVisible && Dialog.isVisible && Dialog.closeOnBlur && $target.closest('.window').length == 0 && $target.closest('body').length > 0
    Dialog.hide()

  else if $target.is('input') || $target.is('textarea') || e.target.attributes['data-reactid']
    Util.stopPropagation(e)
    return

  else if PopOver.isVisible && $target.closest('.pop-over').length > 0
    # They clicked on the popover, we don't need to hide anything

  else if SidebarState.getShowSidebar() && $target.closest('.boards-drawer').length == 0
    if !SidebarState.getPinSidebar()
      trackUe(Noun.HEADER, Verb.CLOSES, Noun.BOARDS_MENU, '', '', 'by clicking outside popover')

    SidebarState.hideUnpinnedSidebar()

  else if $('.new-comment').hasClass('focus')
    $('.new-comment').removeClass('focus').find('textarea').blur()

  else if board?.viewState.get('listComposerOpen')
    board?.viewState.set('listComposerOpen', false)
    @$('.js-open-add-list').removeAttr('tabindex')

  else if board?.composer.get('vis') && !$target.closest('.card-composer').length > 0
    board.composer.save('vis', false)

  else if Layout.isEditing()
    Layout.cancelEdits()

  else if Controller.showingCalendar(boardView) &&
      $target.closest('.calendar-day').length == 0
    $('.calendar-day.active').removeClass('active')

  else
    $('input, textarea').blur()

  $a = $target.closest('a')
  # If it's not a link or they're trying to do some fancy click (that opens in
  # a new tab, etc) don't try to subvert it
  if $a.length && shouldHandleClick(e)
    handleLinkClick(e)

  return



// WEBPACK FOOTER //
// ./app/scripts/views/internal/global-click-handler.coffee